import React from 'react'

function Chef ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 23.98 24'>
      <path d='M6.54,11.45A.55.55,0,0,0,6,10.91a.54.54,0,0,0-.54.54c0,1.44,1.58,3.4,1.76,3.62a.54.54,0,0,0,.86-.66l0,0A6.63,6.63,0,0,1,6.54,11.45Z' />
      <path d='M18,10.91a.54.54,0,0,0-.54.54h0a6.55,6.55,0,0,1-1.52,2.93.55.55,0,0,0,.85.69c.18-.22,1.76-2.18,1.76-3.62a.55.55,0,0,0-.55-.54Z' />
      <path d='M12,10.91a.54.54,0,0,0-.54.54v3.28a.54.54,0,0,0,.54.54.55.55,0,0,0,.55-.54V11.45a.55.55,0,0,0-.55-.54Z' />
      <path d='M18,2.18a5.9,5.9,0,0,0-1,.11,6.53,6.53,0,0,0-9.2-.73A6.29,6.29,0,0,0,7,2.29a6,6,0,0,0-1-.11A6,6,0,0,0,3.28,13.53v8.24A2.22,
                2.22,0,0,0,5.49,24h13a2.23,2.23,0,0,0,2.23-2.23V13.52A6,6,0,0,0,18,2.18Zm1.64,19.6a1.14,1.14,0,0,1-1.14,1.13h-13a1.14,1.14,0,0,1-1.13-1.14h0V19.64H19.63Zm.34-9.1-.09,0a.56.56,0,0,
                0-.25.38v5.45H4.36V13.2a.28.28,0,0,0,0-.09.63.63,0,0,0-.08-.23.57.57,0,0,0-.16-.15L4,12.68A4.91,4.91,0,0,1,6,3.27l.33,0a6.52,6.52,0,0,0-.87,3.26A.54.54,0,0,0,6,7.09a.55.55,0,0,0,
                .55-.54A5.46,5.46,0,1,1,17.45,6.4v.15a.54.54,0,0,0,.54.54.55.55,0,0,0,.55-.54,6.43,6.43,0,0,0-.88-3.26l.33,0a4.91,4.91,0,0,1,2,9.4Z'
      />
    </svg>
  )
}

Chef.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Chef
